import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "small-arrow-left",
  "use": "small-arrow-left-usage",
  "viewBox": "0 0 6.756 11.391",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6.756 11.391\" id=\"small-arrow-left\"><defs><style>#small-arrow-left .a{fill:none;stroke:#342f41;stroke-linecap:round;stroke-width:1.5px;}</style></defs><path class=\"a\" d=\"M151.691,2099.768l-4.635,4.635,4.635,4.635\" transform=\"translate(-145.996 -2098.708)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol